<template>
  <el-dialog 
    title="输入中药副数" 
    :visible.sync="dialogVisible" 
    width="400px" 
    append-to-body 
    :modal-append-to-body="false"
    @open="onDialogOpen"
    @close="onDialogClose"
  >
    <el-form ref="tcmForm" :model="form" :rules="rules" label-width="100px" @submit.native.prevent>
      <el-form-item label="中药副数" prop="dosage">
        <el-input 
          ref="dosageInput"
          v-model="form.dosage" 
          placeholder="请输入副数" 
          type="number"
          :min="1"
          :max="999"
          @keyup.enter.native.prevent="confirmDosage"
        />
      </el-form-item>
   
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmDosage">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'TCMDosageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedCartItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        dosage: ''
      },
      rules: {
        dosage: [
          { required: true, message: '请输入中药副数', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              const num = parseInt(value);
              if (isNaN(num) || num < 1 || num > 999) {
                callback(new Error('副数必须是1-999之间的整数'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    // 弹窗打开事件
    onDialogOpen() {
      // 重置表单
      this.form = {
        dosage: ''
      };
      
      // 如果有选中的商品，可以预填一些信息
      if (this.selectedCartItem && this.selectedCartItem.tcmDosage) {
        this.form.dosage = this.selectedCartItem.tcmDosage;
      }
      
      // 聚焦到输入框
      this.$nextTick(() => {
        if (this.$refs.dosageInput) {
          this.$refs.dosageInput.focus();
          this.$refs.dosageInput.select();
        }
      });
      
      this.$emit('opened');
    },
    
    // 弹窗关闭事件
    onDialogClose() {
      // 清除表单验证
      if (this.$refs.tcmForm) {
        this.$refs.tcmForm.clearValidate();
      }
      this.$emit('close');
    },
    
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    },
    
    // 确认副数
    confirmDosage() {
      this.$refs.tcmForm.validate((valid) => {
        if (valid) {
          const dosageData = {
            dosage: parseInt(this.form.dosage)
          };
   
          this.$emit('confirm', dosageData);
          this.dialogVisible = false;
        } else {
          this.$message.error('请正确填写中药副数');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}
::v-deep .el-form .el-form-item label{
   color: #000 !important;
}
</style>
